<template>
  <div class="page__content campsites">
    <!-- <div class="container"> -->
    <h2 class="page__headline" v-if="campsite && campsite.name">
      {{
        $t("images.headline").replace(/\{\s*CAMPSITE_NAME\s*\}/, campsite.name)
      }}
    </h2>
    <div class="columns">
      <div class="column">
        <p class="page__copy">
          {{ $t("images.copy") }}
        </p>
      </div>
    </div>
    <div class="is-clearfix">
      <router-link
        :to="{ name: 'campsites', params: { lang: lang } }"
        class="button is-primary is-pulled-left"
      >
        {{ $t("generic.back") }}
      </router-link>
    </div>
    <div class="columns">
      <div class="column"></div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="tabs is-boxed">
          <ul>
            <li :class="{ 'is-active': tab == 0 }">
              <router-link
                exact
                :to="{
                  name: 'campsite-images',
                  params: { campsiteId, lang },
                  query: { tab: 0 },
                }"
              >
                <span class="icon is-small"><i class="fa fa-image"></i></span>
                <span>{{ $t("images.edit.buttonLabel") }}</span>
              </router-link>
            </li>
            <li :class="{ 'is-active': tab == 1 }">
              <router-link
                exact
                :to="{
                  name: 'campsite-images',
                  params: { campsiteId, lang },
                  query: { tab: 1 },
                }"
              >
                <span class="icon is-small"
                  ><i class="fa fa-cloud-upload"></i
                ></span>
                <span>{{ $t("images.upload.buttonLabel") }}</span>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column" v-if="tab == 0">
        <image-sort v-model="images"></image-sort>
      </div>
      <div class="column" v-if="tab == 1">
        <div class="container">
          <image-upload></image-upload>
        </div>
      </div>
    </div>

    <div class="is-clearfix">
      <router-link
        :to="{ name: 'campsites', params: { lang: lang } }"
        class="button is-primary is-pulled-left"
      >
        {{ $t("generic.back") }}
      </router-link>
    </div>
    <!-- </div> -->
  </div>
</template>

<script>
import { Api } from '../../../api';
import { ImageSort, ImageUpload } from '../../components';

export default {
    name: 'campsite-images',

    props: {
        lang: {
            type: String,
            required: true,
        },

        campsiteId: {
            type: [Number, String],
            required: true,
        },
    },

    components: {
        ImageSort,
        ImageUpload,
    },

    data() {
        return {
            campsite: null,
            images: [],
        };
    },

    computed: {
        tab() {
            return Number(this.$route.query.tab) || 0;
        },
    },

    beforeRouteEnter(to, from, next) {
        Api.bootstrap().then(function(response) {
            return Promise.all([response, Api.campsites.fetchCampsites(), Api.campsiteImages.fetchImages(to.params.campsiteId)]);
        }).then(function(response) {
            next((vm) => {
                const campsites = response[1].body.filter(ele => {
                    return ele.id === vm.campsiteId;
                });
                if(campsites.length) {
                    vm.campsite = campsites[0];
                }
                vm.images = response[2].body;
                console.log('IMAES ', vm.images);

                if(!vm.images.length) {
                    next({ name: to.name, params: to.params, query: { ...to.query, tab: 1 } });
                }
            });
        });
    },

    beforeRouteUpdate(to, from, next) {
        if(to.query.tab === 0 && from.query.tab === 1) {
            Api.campsiteImages.fetchImages(to.params.campsiteId).then((response) => {
                this.images = response.data;
                next();
            });
        } else {
            next();
        }
    }
};
</script>

<style lang="scss">
@import "campsite-images.scss";
</style>



// WEBPACK FOOTER //
// src/views/pages/campsite-images/campsiteImages.vue